export { default as Login } from "./Login";
export { default as Forgot } from "./Forgot";
export { default as Register } from "./Register";
export { default as ResetPassword } from "./ResetPassword";

require('./account.scss');